<template>
    <div class="entry-content view-courses users-page">
        <v-client-table
			v-if="!preloaderVisibility"
			v-model="courseTemplates"
			:columns="columnsOptions"
			:options="options"
		>
			<div slot="h__name">Name</div>
			<div slot="h__fullName">Student</div>
			<div slot="h__percentCompleted" class="small-cell" />
			<div slot="h__edit" class="small-cell" />
			<BaseProgressBar
				slot="percentCompleted"
				slot-scope="templates"
				:progress="templates.row.percentCompleted"
			/>
			<button
				slot="edit"
				class="nav-item"
				slot-scope="course"
				@click.prevent="onDeleteCourse(course.row.courseId)"
			>
				Delete
			</button>
		</v-client-table>
        <div
            v-if="preloaderVisibility"
            class="table-skeleton"
        />
		<PreloaderComponent v-if="preloaderVisibility"/>
		<Paginate
			v-if="pageCount !== 1 && courseTemplates.length"
			v-model="currentPage"
			:page-count="pageCount"
			:container-class="'pagination'"
			:page-class="'page-item'"
			:prev-text="'<'"
			:next-text="'>'"
			:prev-class="'page-item'"
			:next-class="'page-item'"
			:click-handler="paginationHandler"/>
	</div>
</template>


<script>
import Paginate from 'vuejs-paginate'

import CheckAPI from '@/api'
import BaseProgressBar from '@/components/common/BaseProgressBar'
import PreloaderComponent from '@/components/common/PreloaderComponent'

export const tableOptions = {
	resizableColumns: false,
	perPage: 30,
	perPageValues: [],
	filterable: [],
	highlightMatches: false,
	filterByColumn: false,
	sortable: [],
	skin: '',
	hiddenColumns: ['id'],
	headings: {
		delete: false,
		edit: false
	}
};

export default {
	name: "CourseTemplatePage",
    components: {
        PreloaderComponent,
        Paginate,
		BaseProgressBar
    },
    data() {
		return {
            columnsOptions: ['name', 'fullName', 'percentCompleted', 'edit'],
            courseTemplates: [],
            options: tableOptions,
            pageCount: 0,
            total: 0,
            currentPage: 1,
            size: 30,
            preloaderVisibility: true
        }
    },
    mounted() {
        this.setInitialPage();
    },
    methods: {
        async fetchCourseTemplates() {
			this.currentPage = parseInt(this.$route.query.page)
            const response = await CheckAPI.getCourses(
				this.currentPage - 1,
				this.size
			);
            this.total = response.data.data.total_items
			this.pageCount = response.data.data.total_pages
			const courses = response.data.data.items.map(singleStudent => ({
				...singleStudent,
				fullName: singleStudent.studentFirstName + ' ' + singleStudent.studentLastName
			}))
            this.courseTemplates = courses
            this.preloaderVisibility = false
        },
        setPage() {
			this.currentPage = parseInt(this.$route.query.page || 1);
			this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
			this.fetchCourseTemplates();
		},
		setInitialPage() {
			if (this.$route.query.page !== 1) {
				this.currentPage = parseInt(this.$route.query.page || 1);
				this.$router.push({path: this.$route.path, query: { page: parseInt(this.$route.query.page || 1) }})
				this.fetchCourseTemplates();
			}
		},
		paginationHandler(e) {
			this.currentPage = e;
			this.$router.push({path: parseInt(this.$route.path), query: { page: parseInt(e) }})
			this.preloaderVisibility = true
		},
		async onDeleteCourse(id) {
			await CheckAPI.handleCourseDelete(id)
			if (this.$route.query.page !== 1) {
				this.$router.push({path: this.$route.path, query: { page: 1 }})
			}
			this.fetchCourseTemplates()
		}
    },
    watch: {
		'$route.query.page': {
			deep: true,
			handler() {
				this.preloaderVisibility = true;
				this.setPage();
			}
		}
	}
}
</script>

<style lang="scss">


table {
	thead {
		tr {
			th:nth-child(3) {
				width: 130px !important;
			}
			th:nth-child(4) {
				width: 14% !important;
			}
		}
	}
}


.table-heading {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.pagination {
	list-style: none;
	display: flex;
	justify-content: center;
	padding: 0;

	.page-item {
		transition: .4s ease all;
		background-color: #34558b;

		a {
			display: inline-block;
			padding: 6px 10px;
			color: white;
			border-radius: 6px;
		}

		&.active {
			background-color: #35495e;
		}

		&.disabled {
			a {
				color: #35495e;
				cursor: not-allowed;
			}

			&:hover {
				background-color: #fff;
			}

			background-color: #fff;
		}

		margin: 3px;
		border-radius: 6px;

		&:hover {
			a {
				color: white;
			}

			background-color: #35495e;
		}
	}
}

.view-courses {
	.nav-item {
		color: #141638;
		border: .0625em solid #141638;
		background-color: transparent;
		border-radius: 25px;
		padding: 7px 25px;
		cursor: pointer;
	}
}

.table-skeleton {
  height: 492px;
}


</style>
